import { Brand, Neutrals, Theme } from './colors';

export const TextLinkTheme = {
  TextLinkTextDefault: Theme.main.ThemeWater,
  TextLinkTextHover: Brand.water.Water800,
  TextLinkTextPressed: Brand.water.Water900,
  TextLinkTextDisable: Neutrals.neutralGreys.GreyNatural300,
  TextLinkIconDefault: Theme.main.ThemeWater,
  TextLinkIconHover: Brand.water.Water800,
  TextLinkIconPressed: Brand.water.Water900,
  TextLinkIconDisable: Neutrals.neutralGreys.GreyNatural300,
};
